import { defineMessage } from 'react-intl';

export const navI18n = {
  accountSettings: defineMessage({
    id: 'nav.account-settings',
    defaultMessage: 'Account settings'
  }),
  bookings: defineMessage({
    id: 'nav.bookings',
    defaultMessage: 'Bookings'
  }),
  browseSchools: defineMessage({
    id: 'nav.browse-schools',
    defaultMessage: 'Browse schools'
  }),
  goBackHome: defineMessage({
    id: 'nav.go-back-home',
    defaultMessage: 'Go back home'
  }),
  overview: defineMessage({
    id: 'nav.overview',
    defaultMessage: 'Overview'
  }),
  reviews: defineMessage({
    id: 'nav.reviews',
    defaultMessage: 'Reviews'
  }),
  saved: defineMessage({
    id: 'nav.saved-items',
    defaultMessage: 'Saved'
  })
};
